import moment from 'moment';

export const generateYesterdayDate = () => moment().subtract(1, 'days').format('YYYY-MM-DD');
